<div id="commercial-facility-information-container">
  <form [formGroup]="form()!" id="commercial-facility-form">
    <p-panel
      header="{{ 'COMMERCIAL_SERVICES.LABEL.GENERAL_INFO' | translate }}"
      [toggleable]="true"
      toggler="header"
    >
      <div class="form-grid">
        <div class="row-item">
          <label class="row-label" for="facilityName">
            {{ 'COMMERCIAL_SERVICES.LABEL.FACILITY_NAME' | translate
            }}<span class="required">*</span>
          </label>
          <div class="row-input">
            <input
              id="facilityName"
              type="text"
              pInputText
              formControlName="facilityName"
            />
            <app-inline-validation
              field="facilityName"
              [control]="form()!.controls['facilityName']"
              [validationMessages]="validationMessages()"
            />
          </div>
        </div>
        <div class="row-item">
          <label class="row-label" for="facilityId">
            {{ 'COMMERCIAL_SERVICES.LABEL.FACILITY_ID' | translate
            }}<span class="required">*</span>
          </label>
          <div class="row-input">
            <input
              id="facilityId"
              type="text"
              pInputText
              formControlName="facilityId"
            />
            <app-inline-validation
              field="facilityId"
              [control]="form()!.controls['facilityId']"
              [validationMessages]="validationMessages()"
            />
          </div>
        </div>
        <div class="row-item">
          <label class="row-label" for="facilityTypeId">
            {{ 'COMMERCIAL_SERVICES.LABEL.FACILITY_TYPE' | translate
            }}<span class="required">*</span>
          </label>
          <div class="row-input">
            <p-select
              inputId="facilityTypeId"
              [options]="availableFacilityTypes()"
              formControlName="facilityTypeId"
              optionLabel="label"
              optionValue="value"
              [filter]="true"
              [showClear]="true"
              appendTo="body"
            />
            <app-inline-validation
              field="facilityTypeId"
              [control]="form()!.controls['facilityTypeId']"
              [validationMessages]="validationMessages()"
            />
          </div>
        </div>
        <div class="row-item">
          <label class="row-label" for="companyId">
            {{ 'COMMERCIAL_SERVICES.LABEL.COMPANY' | translate
            }}<span class="required">*</span>
          </label>
          <div class="row-input">
            <p-select
              inputId="companyId"
              [options]="availableCompanies()"
              formControlName="companyId"
              optionLabel="label"
              optionValue="value"
              [filter]="true"
              [showClear]="true"
              appendTo="body"
            />
            <app-inline-validation
              field="companyId"
              [control]="form()!.controls['companyId']"
              [validationMessages]="validationMessages()"
            />
          </div>
        </div>
        <div class="row-item">
          <label class="row-label" for="mcFacilityId">
            {{ 'COMMERCIAL_SERVICES.LABEL.MC_FACILITY_ID' | translate }}
          </label>
          <div class="row-input">
            <div class="input-with-action">
              <p-select
                inputId="mcFacilityId"
                [options]="availableMCFacilities()"
                formControlName="mcFacilityId"
                optionLabel="label"
                optionValue="value"
                [filter]="true"
                [virtualScroll]="true"
                [virtualScrollItemSize]="34"
                [showClear]="true"
                appendTo="body"
              />
              <button
                pButton
                type="button"
                class="input-action"
                icon="fa fa-fw fa-external-link"
                [outlined]="true"
                [disabled]="
                  !canOpenMcFacility() ||
                  !form()!.controls['mcFacilityId'].value
                "
                [attr.aria-label]="
                  'COMMERCIAL_SERVICES.LABEL.OPEN_MC_FACILITY' | translate
                "
                [pTooltip]="
                  'COMMERCIAL_SERVICES.LABEL.OPEN_MC_FACILITY' | translate
                "
                tooltipPosition="top"
                (click)="openMcFacility.emit(form()!.value.mcFacilityId)"
              ></button>
            </div>
          </div>
        </div>
      </div>
    </p-panel>

    <p-panel
      header="{{ 'COMMERCIAL_SERVICES.LABEL.LOCATION' | translate }}"
      [toggleable]="true"
      toggler="header"
    >
      <div class="form-grid">
        <div class="row-item">
          <label class="row-label" for="aorId">
            {{ 'LOCATION.LABEL.AOR' | translate
            }}<span class="required">*</span>
          </label>
          <div class="row-input">
            <p-select
              inputId="aorId"
              [options]="availableAORs()"
              formControlName="aorId"
              optionLabel="label"
              optionValue="value"
              [filter]="true"
              [showClear]="true"
              appendTo="body"
            />
            <app-inline-validation
              field="aorId"
              [control]="form()!.controls['aorId']"
              [validationMessages]="validationMessages()"
            />
          </div>
        </div>
        <div class="row-item">
          <label class="row-label" for="gcSupervisor">
            {{ 'COMMERCIAL_SERVICES.LABEL.GC_SUPERVISOR' | translate }}
          </label>
          <div class="row-input">
            @let gcSupervisor = getDerivedContact('gcSupervisor');
            <div class="input-with-action">
              <input
                id="gcSupervisor"
                type="text"
                pInputText
                [value]="gcSupervisor?.fullName ?? ''"
                disabled
                readonly
              />
              <button
                pButton
                type="button"
                class="input-action"
                icon="fa fa-fw fa-external-link"
                [outlined]="true"
                [disabled]="!canOpenContacts() || !gcSupervisor"
                [attr.aria-label]="
                  'COMMERCIAL_SERVICES.LABEL.OPEN_CONTACT' | translate
                "
                [pTooltip]="
                  'COMMERCIAL_SERVICES.LABEL.OPEN_CONTACT' | translate
                "
                tooltipPosition="top"
                (click)="openContact.emit(gcSupervisor!.id)"
              ></button>
            </div>
          </div>
        </div>
        <div class="row-item">
          <label class="row-label" for="gcManager">
            {{ 'COMMERCIAL_SERVICES.LABEL.GC_MANAGER' | translate }}
          </label>
          <div class="row-input">
            @let gcManager = getDerivedContact('gcManager');
            <div class="input-with-action">
              <input
                id="gcManager"
                type="text"
                pInputText
                [value]="gcManager?.fullName ?? ''"
                disabled
                readonly
              />
              <button
                pButton
                type="button"
                class="input-action"
                icon="fa fa-fw fa-external-link"
                [outlined]="true"
                [disabled]="!canOpenContacts() || !gcManager"
                [attr.aria-label]="
                  'COMMERCIAL_SERVICES.LABEL.OPEN_CONTACT' | translate
                "
                [pTooltip]="
                  'COMMERCIAL_SERVICES.LABEL.OPEN_CONTACT' | translate
                "
                tooltipPosition="top"
                (click)="openContact.emit(gcManager!.id)"
              ></button>
            </div>
          </div>
        </div>
        <div class="row-item">
          <label class="row-label" for="operatingAreaId">
            {{ 'COMMERCIAL_SERVICES.LABEL.OPERATING_AREA' | translate
            }}<span class="required">*</span>
          </label>
          <div class="row-input">
            <p-select
              inputId="operatingAreaId"
              [options]="availableOperatingAreas()"
              formControlName="operatingAreaId"
              optionLabel="label"
              optionValue="value"
              [filter]="true"
              [showClear]="true"
              appendTo="body"
              (onChange)="operatingAreaChanged.emit($event.value ?? null)"
            />
            <app-inline-validation
              field="operatingAreaId"
              [control]="form()!.controls['operatingAreaId']"
              [validationMessages]="validationMessages()"
            />
          </div>
        </div>
        <div class="row-item">
          <label class="row-label" for="marketAreaId">
            {{ 'COMMERCIAL_SERVICES.LABEL.MARKET_AREA' | translate
            }}<span class="required">*</span>
          </label>
          <div class="row-input">
            <p-select
              inputId="marketAreaId"
              [options]="availableMarketAreas()"
              formControlName="marketAreaId"
              optionLabel="label"
              optionValue="value"
              [filter]="true"
              [showClear]="true"
              [disabled]="!form()!.controls['operatingAreaId'].value"
              appendTo="body"
            />
            <app-inline-validation
              field="marketAreaId"
              [control]="form()!.controls['marketAreaId']"
              [validationMessages]="validationMessages()"
            />
          </div>
        </div>
      </div>
    </p-panel>

    <p-panel
      header="{{ 'COMMERCIAL_SERVICES.LABEL.OPERATIONS' | translate }}"
      [toggleable]="true"
      toggler="header"
    >
      <div class="form-grid">
        <div class="row-item">
          <label class="row-label" for="facilityLineSegment">
            {{ 'COMMERCIAL_SERVICES.LABEL.LINE_SEGMENT' | translate }}
          </label>
          <div class="row-input">
            <input
              id="facilityLineSegment"
              type="text"
              pInputText
              formControlName="facilityLineSegment"
            />
          </div>
        </div>
        <div class="row-item">
          <label class="row-label" for="numberOfUnits">
            {{ 'COMMERCIAL_SERVICES.LABEL.NUMBER_OF_UNITS' | translate }}
          </label>
          <div class="row-input">
            <p-inputNumber
              inputId="numberOfUnits"
              mode="decimal"
              [showButtons]="true"
              [step]="1"
              [min]="0"
              [maxFractionDigits]="0"
              formControlName="numberOfUnits"
            />
            <app-inline-validation
              field="numberOfUnits"
              [control]="form()!.controls['numberOfUnits']"
              [validationMessages]="validationMessages()"
            />
          </div>
        </div>
        <div class="row-item">
          <label class="row-label" for="owner">
            {{ 'COMMERCIAL_SERVICES.LABEL.OWNER' | translate }}
          </label>
          <div class="row-input">
            <input id="owner" type="text" pInputText formControlName="owner" />
          </div>
        </div>
        <div class="row-item">
          <label class="row-label" for="operator">
            {{ 'COMMERCIAL_SERVICES.LABEL.OPERATOR' | translate }}
          </label>
          <div class="row-input">
            <input
              id="operator"
              type="text"
              pInputText
              formControlName="operator"
            />
          </div>
        </div>
        <div class="row-item">
          <label class="row-label" for="fuelManager">
            {{ 'COMMERCIAL_SERVICES.LABEL.FUEL_MANAGER' | translate }}
          </label>
          <div class="row-input">
            <input
              id="fuelManager"
              type="text"
              pInputText
              formControlName="fuelManager"
            />
          </div>
        </div>
        <div class="row-item">
          <label class="row-label" for="balancingTypeId">
            {{ 'COMMERCIAL_SERVICES.LABEL.BALANCING_TYPE' | translate }}
          </label>
          <div class="row-input">
            <p-select
              inputId="balancingTypeId"
              [options]="availableBalancingTypes()"
              formControlName="balancingTypeId"
              optionLabel="label"
              optionValue="value"
              [filter]="true"
              [showClear]="true"
              appendTo="body"
            />
          </div>
        </div>
        <div class="row-item contract-item">
          <label class="row-label" for="contract">
            {{ 'COMMERCIAL_SERVICES.LABEL.CONTRACT' | translate }}
          </label>
          <div class="row-input">
            <textarea
              id="contract"
              pTextarea
              [rows]="3"
              formControlName="contract"
            ></textarea>
          </div>
        </div>
        <div class="checkbox-row">
          <div class="checkbox-option">
            <label for="rateableTake">
              {{ 'COMMERCIAL_SERVICES.LABEL.RATEABLE_TAKE' | translate }}
            </label>
            <p-checkbox
              inputId="rateableTake"
              [binary]="true"
              formControlName="rateableTake"
            />
          </div>
          <div class="checkbox-option">
            <label for="criticalDay">
              {{ 'COMMERCIAL_SERVICES.LABEL.CRITICAL_DAY' | translate }}
            </label>
            <p-checkbox
              inputId="criticalDay"
              [binary]="true"
              formControlName="criticalDay"
            />
          </div>
        </div>
      </div>
    </p-panel>
  </form>
</div>
